import Icon from '../components/Icon.vue'

Icon.register({"shekel-sign":{"width":448,"height":512,"paths":[{"d":"M248 168V336C248 344.8 255.2 352 264 352H312C320.8 352 328 344.8 328 336V168C328 92.9 267.1 32 192 32H24C10.8 32 0 42.7 0 56V464C0 472.8 7.2 480 16 480H64C72.8 480 80 472.8 80 464V112H192C222.9 112 248 137.1 248 168zM432 32H384C375.2 32 368 39.2 368 48V344C368 374.9 342.9 400 312 400H200V176C200 167.2 192.8 160 184 160H136C127.2 160 120 167.2 120 176V456C120 469.3 130.8 480 144 480H312C387.1 480 448 419.1 448 344V48C448 39.2 440.8 32 432 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shekel-sign.js
// module id = wJkS
// module chunks = 0